// Support chat is HubSpot Conversations. HubspotLoader injects the script with
// `loadImmediately: false`, so the widget only loads where
// `matchSupportChatToRoute` loads it. The widget is missing when HubSpot is
// blocked (e.g. by an ad blocker) or on routes that hide it, so callers can
// fall back instead.
const SUPPORT_CHAT_HIDDEN_SECTIONS = [
  '/external', // widget routes
  '/admin',
  '/event_admin',
  '/mvp-admin',
  '/sb/admin',
  '/search',
  '/sb/mobile', // universal link routes
];
// The chat launcher covers the homepage search card, so the homepage hides it too.
const SUPPORT_CHAT_HIDDEN_PAGES = ['/', '/home'];

export function isSupportChatShownOn(pathname) {
  return (
    !SUPPORT_CHAT_HIDDEN_PAGES.includes(pathname) &&
    !SUPPORT_CHAT_HIDDEN_SECTIONS.some((section) =>
      pathname.startsWith(section)
    )
  );
}

export function isSupportChatLoaded() {
  try {
    return Boolean(window?.HubSpotConversations?.widget?.status?.().loaded);
  } catch (e) {
    return false;
  }
}

export function whenSupportChatReady(callback) {
  const run = () => {
    try {
      callback();
    } catch (e) {
      // HubSpot's widget must never break the page.
    }
  };

  if (window.HubSpotConversations) {
    run();
  } else {
    window.hsConversationsOnReady = window.hsConversationsOnReady || [];
    window.hsConversationsOnReady.push(run);
  }
}

// A remove() while the widget is still loading doesn't stick, so this also
// runs on HubSpot's `widgetLoaded` event.
export function matchSupportChatToRoute(pathname) {
  const { widget } = window.HubSpotConversations;
  const { loaded } = widget.status();
  const shown = isSupportChatShownOn(pathname);
  if (shown && !loaded) {
    widget.load();
  }
  if (!shown && loaded) {
    widget.remove();
  }
}

export function openSupportChat() {
  whenSupportChatReady(() => window.HubSpotConversations.widget.open());
}
